import { degreeToRadian } from "ixfx/geometry";

export function toMetersPerSec(value: number, unit: string) {
  switch (unit) {
    case "km/h":
      return Math.floor((value * 1000) / 3600);
    default:
      throw new Error(`Unknown unit: ${ unit }`);
  }
}

export function toRadians(value: number, unit: string) {
  switch (unit) {
    case "°":
      return degreeToRadian(value);
    default:
      throw new Error(`Unknown unit: ${ unit }`);
  }
}